import { Autocomplete, Box, TextField } from '@mui/material';
import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import SearchInput from '../../Components/SearchInput';
import accountAPI from '../../Network/Account';
import Cookies from "universal-cookie";

const cookies = new Cookies();

export default function Search({
    filters,
    setFilters
}) {
    const [t] = useTranslation("common");
    const timerAccounts = useRef(null)
    const [accounts, setAccounts] = useState([])
    const [loadingAccounts, setLoadingAccounts] = useState(false)
    const [searchTermAccount, setSearchTermAccount] = useState("");

    const headerObject = {
        username: cookies.get("user_name") ? cookies.get("user_name") : null,
        user_id: cookies.get("user_id") ? cookies.get("user_id") : null,
        account_name: cookies.get("account_name") ? cookies.get("account_name") : null,
        account_id: cookies.get("account_id") ? cookies.get("account_id") : null,
        authHash: cookies.get("authHash") ? cookies.get("authHash") : null,
        sid: cookies.get("sid") ? cookies.get("sid") : null,
        baseurl: cookies.get("baseUrl") ? cookies.get("baseUrl") : null,
        id: cookies.get("id") ? cookies.get("id") : null,
    }

    const loadInitialAccounts = async () => {
        setLoadingAccounts(true);
        const result = await accountAPI.getAccounts({
            params: {
                ...headerObject,
                page_size: 10,
                page: 1
            }
        })
        setLoadingAccounts(false);
        if (result.status && result?.data?.data) {
            setAccounts(result?.data?.data)
        }
    }

    useEffect(() => {
        loadInitialAccounts()
    }, [])

    const handleSearchTermAccountChange = (newValue) => {
        setSearchTermAccount(newValue);
        if (timerAccounts.current) {
            clearTimeout(timerAccounts?.current)
        }
        timerAccounts.current = setTimeout(async () => {
            if (newValue?.length >= 3) {
                setLoadingAccounts(true);
                const result = await accountAPI.getAccounts({
                    params: {
                        ...headerObject,
                        search_account_name: newValue,
                        page_size: 20,
                        page: 1
                    }
                })
                setLoadingAccounts(false);
                if (result.status && result?.data?.data) {
                    setAccounts(result?.data?.data)
                }
            } else if (newValue?.length === 0) {
                loadInitialAccounts()
            } else {
                setAccounts([])
            }
        }, 1000)
    };

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                width: "100% !important",
            }}
        >
            <SearchInput
                value={filters?.name}
                setValue={(value) => {
                    setFilters({
                        ...filters,
                        name: value
                    })
                }}
                title={t('GLOBAL.name')}
            />
            <SearchInput
                value={filters?.code}
                setValue={(value) => {
                    setFilters({
                        ...filters,
                        code: value
                    })
                }}
                title={t('GLOBAL.code')}
            />
            <Autocomplete
                sx={{
                    ml: 1.5, mt: 1, mb: 1, width: '95%',
                    '& .MuiFormLabel-root,& .MuiInputBase-input': {
                        fontFamily: 'Cairo-Medium'
                    }
                }}
                onInputChange={(event, newInputValue) => {
                    handleSearchTermAccountChange(newInputValue);
                }}
                inputValue={searchTermAccount}
                loading={loadingAccounts}
                loadingText={t('GLOBAL.searching')}
                value={filters?.accounts_selected ? filters?.accounts_selected : []}
                options={accounts?.length ? accounts : []}
                multiple={true}
                isOptionEqualToValue={(option, value) => option.account_id === value.account_id}
                getOptionLabel={(option) => {
                    return option && option?.account_name || ""
                }}
                onChange={(e, v) => {
                    setFilters({
                        ...filters,
                        account_ids: v?.length > 0 ? v?.map(acc => acc?.account_id) : [],
                        accounts_selected: v
                    })
                }}
                renderInput={(params) => (
                    <TextField {...params}
                        placeholder={t('GLOBAL.accounts')}
                        variant="standard" sx={{ fontFamily: 'Cairo-Medium' }} />
                )}
            />
        </Box>
    );
}
